import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import { providePrimeNG } from 'primeng/config';
import { environment } from '../environments/environment';
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { provideFirebaseApp } from '@angular/fire/app';
import { provideDatabase } from '@angular/fire/database';
import { DialogService } from 'primeng/dynamicdialog';
import { provideHttpClient } from '@angular/common/http';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { ConfirmationService, MessageService } from 'primeng/api';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { LanguagePipe } from './core/pipes/language.pipe';
import { FormatCurrencyPipe } from './core/pipes/format-currency.pipe';
import { DisplayCurrencyPipe } from './core/pipes/display-currency.pipe';
import { LightPreset } from './theme/mytheme';


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideFirebaseApp(() => initializeApp(environment.database)),
    provideAuth(() => getAuth()),
    provideDatabase(() => getDatabase()),
    provideFirestore(() => getFirestore()),
    provideHttpClient(),
    DialogService,
    MessageService,
    ConfirmationService,
    LanguagePipe,
    FormatCurrencyPipe,
    DisplayCurrencyPipe,
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: LightPreset,
        options: {
          darkModeSelector: '.dark',  
        }
      }
    })
  ],
};
